<template>
  <section class="section-container d-flex justify-content-center align-items-center">
    <div class="card">
      <div class="main-container card-body">
        <div class="head-container text-center">
          <img src="../assets/logo.png" width="120" />
          <h4 class="m-t-15">ไม่สามารถใช้งานบนอุปกรณ์นี้ได้</h4>
        </div>
        <div class="d-grid gap-2 m-t-20">
          <button type="button" @click="goLogin()" class="btn btn-secondary">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" style="margin-top: -4px !important;">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M16.3 5h.7a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h5l-2.82 -2.82m0 5.64l2.82 -2.82" transform="rotate(-45 12 12)" />
            </svg>
            ตรวจสอบอีกครั้ง
          </button>
        </div>
        <div class="note-container text-12 m-t-20" v-html="contact.description"></div>
        <div class="credit-container text-center text-mute text-10 m-t-10" @click="showDeviceInfo()">
          พัฒนาโดย{{ contact.team_develop }}<br />
          อัพเดทล่าสุด {{ dateTimeFormat(last_update) }}
        </div>
        <div v-show="show_device_info === 2" class="info-container m-t-10 text-start text-10">
          <pre>{{ device_info }}</pre>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import apis from '../models/apis'

export default {
  data () {
    return {
      contact: {},
      show_device_info: 1,
      device_info: {
        platform: '',
        useragent: ''
      }
    }
  },
  created () {
    this.getContact()
  },
  mounted () {

  },
  methods: {
    showDeviceInfo () {
      this.device_info.platform = navigator.platform
      this.device_info.useragent = navigator.userAgent
      this.show_device_info = this.show_device_info === 1 ? 2 : 1
    },
    getContact () {
      this.$store.state.is_loading = true
      apis.getContact(
        this.$store.state.api_url,
        { headers: { 'Access-Token': this.$store.state.public_token } },
        result => {
          if (result.response === true) {
            this.contact = result.data
          }
          this.$store.state.is_loading = false
        },
        error => {
          this.$store.state.is_loading = false
          console.log(error.message)
        }
      )
    },
    goLogin () {
      localStorage.clear()
      this.$router.push('/login').catch(() => { })
    }
  }
}
</script>

<style scoped>
.section-container {
  width: 100wh !important;
  height: 100vh !important;
}

.main-container {
  width: 330px !important;
}

.head-container {
  margin: 0 !important;
  padding: 0 !important;
}

.info-container {
  margin: 0 !important;
  padding: 0 !important;
}

.note-container {
  margin: 0 !important;
  padding: 6px !important;
  border: 1px solid rgba(101, 109, 119, 0.16);
  border-radius: 5px;
  font-size: 12px;
  background: #fafbfd;
}

.info-container {
  margin: 0 !important;
  padding: 6px !important;
  border: 1px solid rgba(101, 109, 119, 0.16);
  border-radius: 5px;
  font-size: 10px;
  background: #fafbfd;
}

.credit-container {
  margin: 0 !important;
  padding: 0 !important;
}

.btn-secondary {
  background: #a1780f !important;
  border-color: #a1780f !important;
}

.text-10 {
  font-size: 10px !important;
}

.text-12 {
  font-size: 12px !important;
}

.text-mute {
  color: #727272 !important;
}

.m-t-5 {
  margin-top: 5px !important;
}

.m-t-10 {
  margin-top: 10px !important;
}

.m-t-15 {
  margin-top: 15px !important;
}

.m-t-20 {
  margin-top: 20px !important;
}

.m-b-5 {
  margin-bottom: 5px !important;
}

.m-b-10 {
  margin-bottom: 10px !important;
}

.m-b-15 {
  margin-bottom: 15px !important;
}

pre {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Error.vue